const isPasswordResetByAdmin = (error: any): boolean => {
  const code = error.code;
  return code === "PasswordResetRequiredException";
};

export default isPasswordResetByAdmin;
